import { useCallback } from "react";
import { useI18n } from "components/lni18n";
import {  ModalHeader, ModalBody } from 'reactstrap';
import useTypedSelector from "utils/useTypedSelector";
import Preview from "./Preview";



const ImageAlignDialog = ({ onCancel, onSubmit }) => {

    const { languageService: t } = useI18n();
    const { alignData, imageAlign } = useTypedSelector(state => state.imagepicker);

    const onSubmitImg = useCallback(() => {
        onSubmit(imageAlign);
    }, [imageAlign, alignData]);

    if (!alignData) {
        return null;
    }

    return <>

        <ModalHeader className={""} toggle={onCancel}>{t.getText("image")}</ModalHeader>
        <ModalBody className={""} tabIndex={-1}>
            <Preview  className="mt-5" onSubmit={onSubmitImg} src={alignData.url} />
        </ModalBody>
    </>

}

export default ImageAlignDialog;
